import React from 'react';
import { motion } from 'framer-motion';
import { TRUST_ITEMS } from './offerData';

const OfferTrust: React.FC = () => (
  <section className="py-16 bg-[#2F3136]">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        className="text-center mb-10"
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.45, ease: 'easeOut' }}
      >
        <span className="inline-flex items-center gap-2 rounded-full border border-[#5865F2]/35 bg-[#5865F2]/10 px-4 py-1.5 text-xs font-semibold tracking-wider text-[#9BA8FF] uppercase mb-4">
          Nos engagements
        </span>
        <h2 className="text-balance text-2xl md:text-3xl font-bold text-white mb-3">
          Ce qu'on nous raconte souvent, et ce qu'on fait différemment
        </h2>
        <p className="text-gray-300 max-w-2xl mx-auto">
          Beaucoup d'indépendants nous contactent après une mauvaise expérience avec un prestataire web. Voici les situations qui reviennent le plus, et notre réponse.
        </p>
      </motion.div>

      <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {TRUST_ITEMS.map(({ problem, commitment, icon: Icon }, index) => (
          <motion.li
            key={problem}
            className="flex flex-col rounded-2xl border border-white/15 bg-white/5 p-5 md:p-6"
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.4, ease: 'easeOut', delay: index * 0.05 }}
          >
            <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg bg-[#5865F2]/20">
              <Icon className="h-5 w-5 text-[#9BA8FF]" aria-hidden="true" />
            </div>
            <p className="text-xs uppercase tracking-wider text-gray-400 mb-1">Situation fréquente</p>
            <p className="italic text-gray-200 mb-4">{`«\u00a0${problem}\u00a0»`}</p>
            <p className="text-xs uppercase tracking-wider text-[#AEB9FF] mb-1 mt-auto">Notre engagement</p>
            <p className="text-white font-medium">{commitment}</p>
          </motion.li>
        ))}
      </ul>
    </div>
  </section>
);

export default OfferTrust;
